"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _keycode = _interopRequireDefault(require("keycode"));

var _tabbable = require("tabbable");

var FocusManager = function FocusManager(trapNode, controlNode) {
  var _this = this;

  var useArrowKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var firstFocusIndex = arguments.length > 3 ? arguments[3] : undefined;
  (0, _classCallCheck2.default)(this, FocusManager);

  this.isFocusContained = function (e) {
    return e.target === window && _this.container && !_this.container.contains(document.activeElement);
  };

  this.keyHandler = function (e) {
    if (!document.body.contains(_this.container)) {
      document.removeEventListener('keydown', _this.keyHandler, true);
      return;
    }

    var isPreviousKey = _this.useArrowKeys && e.keyCode === _keycode.default.codes.up || !_this.useArrowKeys && e.keyCode === _keycode.default.codes.tab && e.shiftKey;
    var isNextKey = _this.useArrowKeys && e.keyCode === _keycode.default.codes.down || !_this.useArrowKeys && e.keyCode === _keycode.default.codes.tab;

    if (isPreviousKey || isNextKey) {
      var _context;

      e.preventDefault();

      if (!_this.isFocusContained(e)) {
        _this.tryFocus(_this.tabbableNodes[0]);
      }

      _this.tabbableNodes = (0, _tabbable.tabbable)(_this.container);
      var currentIndex = (0, _indexOf.default)(_context = _this.tabbableNodes).call(_context, e.target);

      if (currentIndex === -1) {
        var _context2;

        // if the event target is not within the tabbable nodes, then
        // chances are it is a nested descendent of one of the tabbable node.
        // For example, it could be button within a grid cell, where that grid cell is tabbable
        // Hence we should check if any of the tabbable nodes contain our target.
        (0, _forEach.default)(_context2 = _this.tabbableNodes).call(_context2, function (eachNode, index) {
          if (eachNode !== null && eachNode !== void 0 && eachNode.contains(e.target)) {
            // if a tabbable node contains our target, that was the node with the current index.
            currentIndex = index;
          }
        });
      }

      var lastNode = _this.tabbableNodes[_this.tabbableNodes.length - 1];
      var firstNode = _this.tabbableNodes[0];

      if (isPreviousKey) {
        if (_this.tabbableNodes[currentIndex] === firstNode) {
          _this.tryFocus(lastNode);
        } else {
          _this.tryFocus(_this.tabbableNodes[currentIndex - 1]);
        }
      } else if (isNextKey) {
        if (_this.tabbableNodes[currentIndex] === lastNode) {
          _this.tryFocus(firstNode);
        } else {
          _this.tryFocus(_this.tabbableNodes[currentIndex + 1]);
        }
      }
    } else if (_this.useArrowKeys && e.keyCode === _keycode.default.codes.tab) {
      // navigate out of component with tab when arrow-key navigation enabled
      e.preventDefault();
      var documentTabbableElements = (0, _tabbable.tabbable)(document);
      var nextElementIndex = (0, _indexOf.default)(documentTabbableElements).call(documentTabbableElements, _this.firstOuterTabbableNode) + (e.shiftKey ? -1 : 1);

      _this.tryFocus(documentTabbableElements[nextElementIndex]);
    }
  };

  this.tryFocus = function (node) {
    if (node) {
      var posX = window.pageXOffset;
      var posY = window.pageYOffset;
      node.focus();
      window.scrollTo(posX, posY);
    }
  };

  this.container = trapNode;
  this.firstOuterTabbableNode = (0, _tabbable.isTabbable)(controlNode) ? controlNode : (0, _tabbable.tabbable)(controlNode)[0];
  this.tabbableNodes = (0, _tabbable.tabbable)(this.container);
  this.useArrowKeys = useArrowKeys;
  document.addEventListener('keydown', this.keyHandler, true);

  if (firstFocusIndex > -1) {
    this.tabbableNodes.length && this.tryFocus(this.tabbableNodes[firstFocusIndex]);
  }
};

exports.default = FocusManager;